module.exports = __webpack_public_path__ + "img/img_52.cb8941fa.png";